/**
 * StatsSection - Metrics/Statistics showcase
 * Features: Animated cards on scroll, hover effects
 */
import { Container, Grid, Box, Paper, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { getStats } from "../constants/stats";

const StatsSection = () => {
  const { t } = useTranslation();
  const stats = getStats(t);

  return (
    <Box sx={{ bgcolor: "background.paper", py: 6 }}>
      <Container>
        <Typography
          variant="overline"
          align="center"
          display="block"
          sx={{ color: "primary.main", fontWeight: 700, letterSpacing: "0.15em", mb: 1 }}
        >
          {t("home.stats.eyebrow")}
        </Typography>
        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Paper
                  elevation={3}
                  sx={{
                    p: 4,
                    textAlign: "center",
                    borderTop: "3px solid",
                    borderColor: "primary.main",
                    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      borderColor: "secondary.main",
                      boxShadow: (theme) =>
                        `0 16px 32px ${theme.palette.primary.main}28`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      color: "primary.main",
                      mb: 1.5,
                      "& svg": {
                        filter: (theme) =>
                          `drop-shadow(0 2px 8px ${theme.palette.primary.main}55)`,
                      },
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 800,
                      fontSize: { xs: "2.4rem", md: "3rem" },
                      color: "primary.main",
                      lineHeight: 1,
                      mb: 0.5,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                  >
                    {stat.label}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default StatsSection;
